import React from 'react';
import { styled, type StyledProps } from '@compiled/react';

import { LoadableAfterPaint } from '@confluence/loadable';
import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';

import { VIEW_PAGE_LABELS_METRIC } from './perf.config.ts';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LabelsSelectPlaceholder: React.ComponentType<
	React.ClassAttributes<HTMLDivElement> & React.HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.div({
	width: '100%',
	height: '40px',
});

const ViewPageLabelsLoaderBase = LoadableAfterPaint({
	loading: () => <LabelsSelectPlaceholder />,
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ViewPageLabels" */ './ViewPageLabels.tsx'))
			.ViewPageLabels,
});

export const ViewPageLabelsLoader = (props: any): React.JSX.Element => (
	<>
		<PageSegmentLoadStart metric={VIEW_PAGE_LABELS_METRIC} />
		<ViewPageLabelsLoaderBase {...props} />
	</>
);
